import Operator from "./Operator";
export default Operator;